import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

import { Pupil } from '@df/interfaces';
import { PupilService } from '@app/student/services/pupil.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-coach',
    templateUrl: './coach.component.html',
    styleUrls: ['./coach.component.scss']
})
export class CoachComponent implements OnInit, OnDestroy {
    choicedPupil: Pupil;

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(private pupilService: PupilService, private router: Router) {}

    ngOnInit() {
        this.choicedPupil = this.pupilService.getCurrentPupil();
        if (!this.choicedPupil) {
            this.router.navigate(['/student/class']);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
    }
}
